import { Injectable } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { DesignationActions } from '../transaction-store/designation';
import { OptInActions, OptIns } from '../transaction-store/opt-ins';
import { RecurringActions } from '../transaction-store/recurring';
import { AppSettings } from '../app.settings';
import { Donation, DonationType } from '../transaction-store/donation';
import { Observable } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { PaymentInfoActions } from '../transaction-store/payment-info';
import { environment } from '../../environments/environment';
import { Sdk } from './sdk.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private designations: any[] = this.settings.getValue('organization')
    .designations;
  @Select() optIns$: Observable<OptIns>;
  @Select() donation$: Observable<Donation>;
  cashFixed = 0;
  checkFixed = 0;
  cashRatio = 1.0;
  checkRatio = 1.0;
  constructor(
    private store: Store,
    private settings: AppSettings,
    private sdk: Sdk
  ) {
    this.formatDesignation = this.formatDesignation.bind(this);
    const org = this.settings.getValue('organization');
    this.cashFixed = org.attributes['config.donor_fee.cash_fixed'];
    this.cashRatio = org.attributes['config.donor_fee.cash_ratio'];
    this.checkFixed = org.attributes['config.donor_fee.echeck_fixed'];
    this.checkRatio = org.attributes['config.donor_fee.echeck_ratio'];
  }

  // listen for and handle postMessages (from cart, etc) and dispatch actions directly
  public listen() {
    let paysFee = false;
    let feeAmount = 0;
    const tokenizerUrl = new URL(this.sdk.client.config.cardConnectTokenizerUrl);
    window.addEventListener('message', (payload: any) => {
      let data;
      try {
        data = JSON.parse(payload.data);
      } catch (e) {
        data = payload.data;
      }

      const isCardConnect = payload.origin.indexOf(tokenizerUrl.origin) > -1;

      // TODO: will need to pass in the important token origin / url at least
      if (isCardConnect) {
        if (data.validationError) {
          // errors are machine gunned and not grouped, making this really akward.
          // overwriting as they come and displaying last error given.
          this.store.dispatch(
            new PaymentInfoActions.SetTokenValidation(data.validationError)
          );
        } else if (data.message) {
          // message in one thing token in another :(
          this.store.dispatch(new PaymentInfoActions.SetToken(data.message));
          this.store.dispatch(new PaymentInfoActions.SetTokenValidation(''));
        }
      }

      // designation messages come from ABWE's cart
      if (data.designations) {
        const filteredDesignations = data.designations
          .map(this.formatDesignation)
          .filter(removeUndefined);
        this.store.dispatch(
          new DesignationActions.SetDesignations(filteredDesignations)
        );
        // DO NOT SetCartDesignations here.
      }

      if (data.details) {
        this.store.dispatch(
          new OptInActions.SetEmails(!!data.details.email_opt_in)
        );
      }

      if (data.frequency) {
        this.store.dispatch(new RecurringActions.SetFrequency(data.frequency));
      }

      if (data.designation_note) {
        this.store.dispatch(
          new DesignationActions.SetCustomDesignation(data.designation_note)
        );
      }

      if (data.details) {
        if (isNullOrUndefined(data.details.donor_paid_fee)) {
          this.store.dispatch(
            new OptInActions.SetPayFee({ enabled: false, amount: feeAmount })
          );
        } else {
          this.store.dispatch(
            new OptInActions.SetPayFee({
              enabled: data.details.donor_paid_fee,
              amount: feeAmount
            })
          );
        }
      }
    });

    this.optIns$.subscribe(optIns => {
      paysFee = optIns.payFee;
      feeAmount = optIns.feeAmount;
    });

    const calculateFee = (amount, ratio, fixed) => {
      return this.roundHalfEven((amount * ratio + fixed) * 100.0) / 100.0;
    };

    // TODO : find out why this chunk of code updating feeAmount exists
    this.donation$.subscribe(donation => {
      if (donation.type === DonationType.Check) {
        feeAmount = calculateFee(donation.amount, this.checkRatio, this.checkFixed);
      } else {
        feeAmount = calculateFee(donation.amount, this.cashRatio, this.cashFixed);
      }
      this.store.dispatch(
        new OptInActions.SetPayFee({ enabled: paysFee, amount: feeAmount })
      );
    });
  }

  // TODO: also implemented in opt-ins.component.ts
  // These should be consolidated when ABWE/app6 interactions become clearer
  private roundHalfEven(value) {
    // "banker's rounding", 1.5 -> 2, 2.5 -> 2, 3.5 -> 4 etc
    if (value % 0.5 !== 0) {
      return Math.round(value);
    }

    return Math.floor(value) % 2 === 0 ? Math.floor(value) : Math.round(value);
  }

  private formatDesignation(des) {
    const designation = this.designations.find(
      item => item.id === des.designation_id
    );
    if (designation) {
      return {
        ...des,
        id: des.designation_id,
        title: designation.title
      };
    } else {
      return undefined;
    }
  }
}

function removeUndefined(x: any) {
  return x !== undefined;
}
